import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { twMerge } from 'tailwind-merge';
import { SETTING_KEYS } from 'utils/common/const';

const RulePage = () => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />
        <div
          className="mx-auto max-w-[900px] bg-white/95 border-2 border-solid shadow shadow-primary p-4 w-full md:pb-8 md:pt-4 rounded-3xl"
          style={{
            background: '#FFFFFF80',
            borderColor: '#26A9E0',
            borderRadius: '1.5rem'
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RulePage;
